import styled from 'styled-components';
import { motion } from 'framer-motion';

import { media } from 'utils/detection';
import { hoverSpringMedium } from 'utils/motion';
import FooterLink from 'components/FooterLink';

export default styled(({ className, isBack, ...restProps }) => (
  <motion.div
    className={className}
    whileHover={{ x: isBack ? -10 : 10 }}
    transition={hoverSpringMedium}
  >
    <FooterLink isBack={isBack} {...restProps} />
  </motion.div>
))`
  display: block;
  padding: 0;
  margin: 0 0 36px 0;

  ${media.medium`
    display: inline-block;
    margin: 0 2.5vw;
  `}
`;